import React, { useCallback, useMemo } from 'react';
import { BetaBadgeWrapper } from 'framework/ui/ui-builder';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { useStaffingProjectContext } from '../context/StaffingProjectContext';
import { getStaffingProjectUrl, getStaffingProjectTabUrl, STAFFING_PROJECT_TAB } from 'domain/shared/project';
import { TabItem, TabsWrapper } from 'framework/ui/TabsWrapper';

const StaffingProjectTabsMenu = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { project } = useStaffingProjectContext();
  const { isFeatureEnabled } = useFeatureToggle();

  const baseUrl = getStaffingProjectUrl(projectId ?? project.id.toString());
  const staffingUrl = baseUrl;
  const trendsUrl = getStaffingProjectTabUrl(projectId ?? project.id.toString(), STAFFING_PROJECT_TAB.TRENDS);
  const timelineUrl = getStaffingProjectTabUrl(projectId ?? project.id.toString(), STAFFING_PROJECT_TAB.TIMELINE);

  const onChangeTab = useCallback(
    (route: string) => {
      navigate(route, { preventScrollReset: true });
    },
    [navigate],
  );

  const tabs: TabItem[] = useMemo(
    () => [
      {
        label: <BetaBadgeWrapper>Staffing</BetaBadgeWrapper>,
        value: staffingUrl,
        route: staffingUrl,
        onClick: () => onChangeTab(staffingUrl),
        isVisible: true,
      },
      {
        label: <BetaBadgeWrapper>Trends</BetaBadgeWrapper>,
        value: trendsUrl,
        route: trendsUrl,
        onClick: () => onChangeTab(trendsUrl),
        isVisible: isFeatureEnabled(Features.STAFFING_CHARTS),
      },
      {
        label: <BetaBadgeWrapper>Timeline</BetaBadgeWrapper>,
        value: timelineUrl,
        route: timelineUrl,
        onClick: () => onChangeTab(timelineUrl),
        isVisible: true,
      },
    ],
    [staffingUrl, trendsUrl, timelineUrl, onChangeTab, isFeatureEnabled],
  );

  const currentTab = tabs.find(({ value }) => location.pathname === value)?.value ?? staffingUrl;

  return (
    <TabsWrapper
      defaultTab={currentTab}
      sxContentProps={{}}
      isShowContent={false}
      sxTabs={{
        overflow: 'auto',
        minHeight: 'auto',
      }}
      sxTab={{
        minHeight: '40px',
        minWidth: 'auto',
        whiteSpace: 'nowrap',
        padding: '12px 8px',
      }}
      tabs={tabs}
    />
  );
};

export default StaffingProjectTabsMenu;
